'use client'
import PlaceHolder from '@/assets/images/placeholder/player-1.png'
import { ForeignP, GreenUpArrow, RedDownArrow, RightArrow } from '@/shared/Icons'
import { getImgURL, getPlayerRole } from '@/shared/utils'
import { useState } from 'react'
import CommonNav from '../commonNav'
import CustomLink from '../customLink'
import MyImage from '../myImage'

function PlayingXI({ data, toss }: any) {
  const [open, setOpen] = useState(true)
  const tabs = [
    {
      navItem: data?.getMatchOverviewFront?.oTeam1?.oTeam?.sAbbr,
      value: data?.getMatchOverviewFront?.oTeam1?.oTeam?._id
    },
    {
      navItem: data?.getMatchOverviewFront?.oTeam2?.oTeam?.sAbbr,
      value: data?.getMatchOverviewFront?.oTeam2?.oTeam?._id
    }
  ]
  const [selectedTab, setSelectedTab] = useState(tabs[0] || {})
  const oTeam1Squads: any = { playingXI: [], reserve: [] }
  if (data?.getMatchOverviewFront.oTeam1.aPlayers?.length) {
    for (const player of data.getMatchOverviewFront.oTeam1.aPlayers) {
      if (player?.bPlaying11 || (player?.bSubstitute && player?.bPlaying11)) {
        oTeam1Squads.playingXI.push(player)
      }
      if (!player?.bPlaying11 && !player?.bSubstitute) {
        oTeam1Squads.reserve.push(player)
      }
    }
  }

  const oTeam2Squads: any = { playingXI: [], reserve: [] }
  if (data?.getMatchOverviewFront.oTeam2.aPlayers?.length) {
    for (const player of data.getMatchOverviewFront.oTeam2.aPlayers) {
      if (player?.bPlaying11 || (player?.bSubstitute && player?.bPlaying11)) {
        oTeam2Squads.playingXI.push(player)
      }
      if (!player?.bPlaying11 && !player?.bSubstitute) {
        oTeam2Squads.reserve.push(player)
      }
    }
  }

  const currentTeam =
    selectedTab?.value === data?.getMatchOverviewFront?.oTeam1?.oTeam?._id
      ? oTeam1Squads
      : oTeam2Squads

  // Render player component to avoid repetition
  const renderPlayer = (p: any, i: number) => {
    const hasSpecialRole = p?.isCaptain || (p?.bSubstitute && p?.bPlaying11) || p?.bIsForeign
    const sShortName =
      `${p?.oPlayer?.sFullName?.split(' ')?.[0]?.[0] || ''} ${p?.oPlayer?.sFullName?.split(' ')?.[1]}` ||
      ''
    const playerContent = (
      <>
        <MyImage
          src={p?.oPlayer?.oImg?.sUrl ? getImgURL(p?.oPlayer?.oImg?.sUrl) : PlaceHolder}
          width={48}
          height={48}
          className="aspect-square rounded-full flex-shrink-0 border border-tabBorder"
          alt="player"
        />
        <div>
          <p className="text-sm font-medium text-textOffWhite flex items-center gap-1">
            <span
              className={`inline-flex items-center gap-1 ${hasSpecialRole ? 'max-w-full' : 'max-w-full'}`}
            >
              <span className="whitespace-nowrap w-full">{sShortName} </span>
              {p?.isCaptain && (
                <span
                  className={`border-c border w-4 h-4 text-t-note flex items-center justify-center text-[10px] md:text-xxs font-medium rounded-full`}
                >
                  C
                </span>
              )}
              {p?.bSubstitute && p?.bPlaying11 && (
                <span className="px-0.5 bg-green-600 text-[10px] rounded-sm text-white leading-4">
                  IMP
                </span>
              )}
              {p?.bIsForeign && (
                <span className="min-w-2.5">
                  <ForeignP />
                </span>
              )}
            </span>
          </p>
          <p className="text-textDselected text-[10px] flex items-center gap-1">
            {p?.isWicketKeeper ? 'Wicket Keeper' : getPlayerRole(p?.sRoleStr)}{' '}
            {p?.bIn && (
              <span className="flex gap-0.5 items-center">
                <span className="text-primary">In</span>
                <GreenUpArrow />
              </span>
            )}
            {p?.bOut && (
              <span className="flex gap-0.5 items-center">
                <span className="text-red-600">Out</span>
                <RedDownArrow />
              </span>
            )}
          </p>
        </div>
      </>
    )

    if (p?.oPlayer?.oSeo?.sSlug) {
      return (
        <CustomLink
          key={i}
          href={`/${p?.oPlayer?.oSeo?.sSlug}`}
          className="flex items-center gap-2"
        >
          {playerContent}
        </CustomLink>
      )
    } else {
      return (
        <div key={i} className="flex items-center gap-2">
          {playerContent}
        </div>
      )
    }
  }

  return (
    <div>
      <p className="sm:text-lg text-textOffWhite mb-4">{toss ? `Playing XI` : 'Squads'}</p>
      <CommonNav
        items={tabs}
        variant="pills"
        asButton
        tabClassName="!font-normal text-xs text-nowrap"
        className=" grid grid-cols-2 mb-6"
        onTabChange={(e: any) => setSelectedTab(e)}
        isActive={item => item?.value === selectedTab?.value}
      />
      {currentTeam?.playingXI.length ? (
        <div className="grid grid-cols-2 gap-5 pb-4 border-b border-tabBorder mb-4">
          {currentTeam?.playingXI?.map((p: any, i: number) => renderPlayer(p, i))}
        </div>
      ) : null}

      {toss && currentTeam?.reserve?.length ? (
        <button
          className="flex items-center gap-2 justify-between text-lg font-medium w-full text-subSectionText mb-5"
          onClick={() => setOpen(!open)}
        >
          On Bench
          <span
            className={`block h-4 w-4 transition-transform ${open ? 'rotate-90' : '-rotate-90'}`}
          >
            <RightArrow />
          </span>
        </button>
      ) : null}

      {open && (
        <div className="grid grid-cols-2 gap-5 pb-4 border-b border-tabBorder mb-4">
          {currentTeam?.reserve?.map((p: any, i: number) => renderPlayer(p, i))}
        </div>
      )}
    </div>
  )
}

export default PlayingXI
